import { cartStore } from './cart.store';
import { navigate } from 'svelte-routing';
import { persistStore } from './persistStorage';

export const orderStore = persistStore('order-store', []);

export const placeOrder = (data) => {
	orderStore.update((orders) => {
		orders = [
			...orders,
			{
				name: data?.name,
				email: data?.email,
				phone: data?.phone,
				address: data?.address,
				city: data?.city,
				country: data?.country,
				postal: data?.postal,
				items: data?.items,
				total: data?.items?.reduce(
					(acc, item) => acc + Number(item.price) * Number(item.quantity),
					0
				),
				quantities: data?.items?.reduce(
					(acc, item) => acc + Number(item.quantity),
					0
				),
				createdAt: new Date(),
				orderNumber: `#${Math.floor(Math.random() * 1000000)}`,
				id: Math.floor(Math.random() * 1000000),
			},
		];
		cartStore.set([]);
		navigate('/orders');
		alert('Order placed successfully');
		return orders;
	});
};
